import {
  ACTIVITY_THRESHOLD_TYPE,
  ANALYTICS_FILTER_TYPE,
  ANALYTICS_GRAPHS_TYPE,
  CUSTOMER_DETAIL_TYPE,
  CUSTOMER_FULL_QUOTE_TYPE,
  CUSTOMER_PN_TYPE,
  CUSTOMER_QUOTE_ACTIVITY_TYPE,
  CUSTOMER_QUOTE_GRAPHS_TYPE,
  CUSTOMER_QUOTE_HISTORY_TREND_TYPE,
  CUSTOMER_QUOTE_KPI_TYPE,
  GET_GRAPHS_LIST_TYPE,
  PART_NUMBER_LIST_TYPE,
  UPDATE_ACTIVITY_THRESHOLD_TYPE,
} from "../../../constant/asynActionsType";
import { createAppAsyncThunk } from "../../../utils/createAppAsyncThunk";
import {
  GetActivityThresholdService,
  GetAnalyticsFiltersService,
  GetAnalyticsGraphsService,
  GetCustomerDetailService,
  GetCustomerPNService,
  GetCustomerQuoteActivityService,
  GetCustomerQuoteGraphsService,
  GetCustomerQuoteKPIService,
  GetFullQuoteService,
  GetGraphsListService,
  GetPartNumbersService,
  GetQuoteHistoryTrendService,
  UpdateActivityThresholdService,
} from "./analyticsServices";

export const getGraphsList = createAppAsyncThunk(
  GET_GRAPHS_LIST_TYPE,
  GetGraphsListService
);

export const analyticsFilterDropdowns = createAppAsyncThunk(
  ANALYTICS_FILTER_TYPE,
  GetAnalyticsFiltersService
);

export const analyticsGraphsJSON = createAppAsyncThunk(
  ANALYTICS_GRAPHS_TYPE,
  GetAnalyticsGraphsService
);

export const getPartNumberList = createAppAsyncThunk(
  PART_NUMBER_LIST_TYPE,
  GetPartNumbersService
);

export const getCustomerQuoteKPIData = createAppAsyncThunk(
  CUSTOMER_QUOTE_KPI_TYPE,
  GetCustomerQuoteKPIService
);

export const getCustomerQuoteActivityData = createAppAsyncThunk(
  CUSTOMER_QUOTE_ACTIVITY_TYPE,
  GetCustomerQuoteActivityService
);

export const getCustomerQuoteGraphsData = createAppAsyncThunk(
  CUSTOMER_QUOTE_GRAPHS_TYPE,
  GetCustomerQuoteGraphsService
);

export const getActivityThresholdData = createAppAsyncThunk(
  ACTIVITY_THRESHOLD_TYPE,
  GetActivityThresholdService
);

export const updateActivityThreshold = createAppAsyncThunk(
  UPDATE_ACTIVITY_THRESHOLD_TYPE,
  UpdateActivityThresholdService,
  {
    successMessage: { show: true, message: "Thresholds updated successfully" },
    errorMessage: { show: true, message: "Failed to update thresholds" },
  }
);

export const getCustomerQuoteHistoryTrendData = createAppAsyncThunk(
  CUSTOMER_QUOTE_HISTORY_TREND_TYPE,
  GetQuoteHistoryTrendService
);

export const getCustomerPNData = createAppAsyncThunk(
  CUSTOMER_PN_TYPE,
  GetCustomerPNService
);

export const getFullQuotesData = createAppAsyncThunk(
  CUSTOMER_FULL_QUOTE_TYPE,
  GetFullQuoteService
);

export const getCustomerDetailData = createAppAsyncThunk(
  CUSTOMER_DETAIL_TYPE,
  GetCustomerDetailService
);
